define.alias("shared/components/shared/post-tagging/select/tag-select-multiple", "media/components/shared/post-tagging/select/tag-select-multiple");